<template>
  <div>
    <div v-if="editing">
      <div class="row">
        <draggable :list="images" handle=".grabbable">
          <div class="col-4 mb-3 d-flex align-items-center" v-for="(file, index) in images" :key="file || index">
            <i class="fas fa-bars grabbable me-3"></i>
            <ImageUpload
              :file-path="file"
              context="component.gallery"
              @uploadCompleted="storeFile(index, $event)"
              @fileDeleted="deleteFile(index)"
            ></ImageUpload>
          </div>
        </draggable>
        <div class="text-center col-12">
          <button class="btn btn-primary" @click="newFile">{{ 'Add' | translate }}</button>
        </div>
      </div>
    </div>
    <div v-else class="row">
      <div v-for="url in images" :key="url" class="col-4 text-center">
        <img
          :src="`https://skyier-bucket.s3.eu-west-1.amazonaws.com/${url}`"
          alt=""
          class="img-fluid"
          style="max-height: 200px"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ImageUpload from './../ImageUpload'
import _ from 'lodash'
import draggable from 'vuedraggable'

export default {
  components: {
    ImageUpload,
    draggable,
  },
  props: ['component', 'editing'],
  data() {
    return {
      newFilePath: null,
      images: _.get(this.component.data, 'images') || [],
    }
  },
  mounted() {
    if (_.isArray(this.component.data)) {
      this.component.data = {}
    }
  },
  methods: {
    newFile() {
      this.images.push('')
    },
    deleteFile(index) {
      this.$delete(this.images, index)
      _.set(this.component, 'data.images', this.images)
      this.$emit('fileDeleted')
    },
    storeFile(index, filePath) {
      this.$set(this.images, index, filePath)
      _.set(this.component, 'data.images', this.images)
      this.$emit('fileUploaded')
    },
  },
}
</script>

<style></style>
